export default "__VITE_ASSET__COEjP4jR__"